import BaseComponent from "@js/components/base_component.jsx";
import EuiDnsStatusPanel from "@js/components/eui/dns_status_panel.jsx";
import EuiLinkedConfigurationRow from "@js/components/eui/linked_configuration_row.jsx";
import EuiUrlDomainCertStatus from "@js/components/eui/url_domain_cert_status.jsx";

class EuiSharedTrackingDomainsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    var std = props.shared_tracking_domain;
    this.state = {
      domain: std.domain || "",
      url_domain: this._stripDomainSuffix(std.url_domain, std.domain),
      bounce_domain: this._stripDomainSuffix(std.bounce_domain, std.domain),
    };
  }

  render() {
    const std = this.props.shared_tracking_domain;
    const isNew = !std.persisted;
    const domain = this.state.domain;
    const urlDomainSuffix = this.state.url_domain && domain ? "." + domain : domain;
    const bounceDomainSuffix = this.state.bounce_domain && domain ? "." + domain : domain;

    // Object with subdomain-only values for the InputField defaultValue
    const subdomainDisplay = Object.assign({}, std, {
      url_domain: this.state.url_domain,
      bounce_domain: this.state.bounce_domain,
    });

    return (
      <div>

        <ErrorBanner entity={ std } />

        <Panel heading="shared_tracking_domain_settings">
          <div className="form-horizontal">

            { isNew ? (
              <InputField
                object={ std }
                type="shared_tracking_domain"
                field="domain"
                editing={ true }
                onChange={ (e) => this.setState({ domain: e.target.value }) }
                helpRawHtml={ I18n.t("simple_form.hints.shared_tracking_domain.domain_html") }
              />
            ) : (
              <FieldContainer labelText={ I18n.t("simple_form.labels.shared_tracking_domain.domain") } helpRawHtml={ this._help(I18n.t("simple_form.hints.shared_tracking_domain.domain_html")) }>
                { std.domain }
              </FieldContainer>
            )}

            { isNew ? (
              <SelectField
                field="shared_tracking_domain.cname_suffix_domain"
                blank={ null }
                value={ std.cname_suffix_domain }
                options={ this._cnameSuffixDomainOptions() }
                editing={ true }
                error={ std.errors ? std.errors.cname_suffix_domain : null }
                helpRawHtml={ I18n.t("simple_form.hints.shared_tracking_domain.cname_suffix_domain_html") }
              />
            ) : (
              <FieldContainer labelText={ I18n.t("simple_form.labels.shared_tracking_domain.cname_suffix_domain") } helpRawHtml={ this._help(I18n.t("simple_form.hints.shared_tracking_domain.cname_suffix_domain_html")) }>
                { std.cname_suffix_domain }
              </FieldContainer>
            )}

            { isNew ? (
              <React.Fragment>
                <InputField
                  object={ subdomainDisplay }
                  type="shared_tracking_domain"
                  field="url_domain"
                  name="_url_domain_subdomain"
                  editing={ true }
                  inputAddonSuffix={ urlDomainSuffix }
                  placeholder={ I18n.t("phrases.optional_defaults_to_domain") }
                  onChange={ (e) => this.setState({ url_domain: e.target.value }) }
                  helpRawHtml={ I18n.t("simple_form.hints.shared_tracking_domain.url_domain_html") }
                />
                <input type="hidden" name="shared_tracking_domain[url_domain]" value={ this._fullDomain(this.state.url_domain, domain) } />

                <InputField
                  object={ subdomainDisplay }
                  type="shared_tracking_domain"
                  field="bounce_domain"
                  name="_bounce_domain_subdomain"
                  editing={ true }
                  inputAddonSuffix={ bounceDomainSuffix }
                  placeholder={ I18n.t("phrases.optional_defaults_to_domain") }
                  onChange={ (e) => this.setState({ bounce_domain: e.target.value }) }
                  helpRawHtml={ I18n.t("simple_form.hints.shared_tracking_domain.bounce_domain_html") }
                />
                <input type="hidden" name="shared_tracking_domain[bounce_domain]" value={ this._fullDomain(this.state.bounce_domain, domain) } />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <FieldContainer labelText={ I18n.t("simple_form.labels.shared_tracking_domain.effective_url_domain") } helpRawHtml={ this._help(I18n.t("simple_form.hints.shared_tracking_domain.url_domain_html")) }>
                  { std.effective_url_domain }
                </FieldContainer>

                <FieldContainer labelText={ I18n.t("simple_form.labels.shared_tracking_domain.effective_bounce_domain") } helpRawHtml={ this._help(I18n.t("simple_form.hints.shared_tracking_domain.bounce_domain_html")) }>
                  { std.effective_bounce_domain }
                </FieldContainer>
              </React.Fragment>
            )}

            { !this.props.editing && (
              <EuiLinkedConfigurationRow
                incoming_email_domain_id={ std.incoming_email_domain_id }
                url_domain_id={ std.url_domain_id }
              />
            )}

            { !this.props.editing && (
              <EuiUrlDomainCertStatus tls_cert={ std.url_domain_https_status } />
            )}

          </div>
        </Panel>

        { !this.props.editing && (
          <EuiDnsStatusPanel
            domain={ std.domain }
            dns_verified={ std.dns_verified }
            dns_verified_time_pretty={ std.dns_verified_time_pretty }
            dns_regression={ std.dns_regression }
            dns_regression_time_pretty={ std.dns_regression_time_pretty }
            wanted_dns_records={ std.wanted_dns_records }
            unwanted_dns_records={ std.unwanted_dns_records }
          />
        )}

      </div>
    );
  }

  // Help text only appears on the new page, not the read-only view page, where
  // it is visual noise. Only the view page (the Show wrapper) passes
  // editing={false} explicitly; while creating, the flag is true or undefined,
  // so hide help solely when it is explicitly false.
  _help(html) {
    return this.props.editing === false ? null : html;
  }

  _cnameSuffixDomainOptions() {
    return (this.props.allowed_cname_suffix_domains || []).map(function(d) {
      return { value: d, label: d };
    });
  }

  _stripDomainSuffix(fullDomain, domain) {
    if (!fullDomain || !domain) return fullDomain || "";
    var suffix = "." + domain.toLowerCase();
    if (fullDomain.toLowerCase().endsWith(suffix)) {
      return fullDomain.slice(0, -suffix.length);
    }
    return "";
  }

  _fullDomain(subdomain, domain) {
    if (!subdomain) return "";
    if (!domain) return subdomain;
    return subdomain + "." + domain;
  }

}

export default EuiSharedTrackingDomainsForm;
